import { makeObservable, observable } from 'mobx'
import React from 'react'

class SurveyDataImportStore {
    constructor(store) {
        this.store = store
        this.request.userId = this.store.tokenData.userId
        this.initializeTableColumns()
        makeObservable(this)
    }

    texts = [
        {
            key: 'requiredFields',
            name: 'Required fields',
            value: '"ID", "surveyDataId", "surveyId", "surveyUserId", "surveyDataType", "status", "startDate", "completedDate", "browserType", "deviceType", "userAgent", "langcode", "lastSurveyPageId", "lastStandardPageId", "lastConfirmationPageId", "lastExitPageId"',
        },
        {
            key: 'userColumns',
            name: 'Survey User columns (optional)',
            value: '"surveyUserId", "emailAddress", "salutation", "firstName", "lastName", "jobTitle", "companyName"',
        },
        {
            key: 'ignored',
            name: 'Ignored (but accepted) columns',
            value: '"source", "completionStatus", "campaignLink"',
        },
    ]

    @observable request = {
        kind: 'surveyDataImport',
        userId: '',
        surveyId: '',
        langcode: 'en_GB',
        fileName: '',
    }

    @observable tableData = []

    @observable allData = []

    tableHeaders = []

    @observable tableColumns = []

    file = null

    socket = null

    @observable uploadStarted = false

    @observable pending = false

    @observable responseMetadata = {
        totalSurveyDataOptRecords: '',
        totalSurveyDataRecords: '',
        totalSurveyDataIntRecords: '',
        totalSurveyDataStrRecords: '',
        totalSurveyUserRecords: '',
        totalRecords: '',
        totalCellUpdateFailures: '',
        totalRecordsWithCellUpdateFailures: '',
    }

    expandableData

    userDetails = ['email', 'optout', 'companyname', 'firstname', 'surveyId', 'lastname', 'jobtitle', 'isNew', 'surveyUserId', 'kind', 'surveyUserType']

    @observable confirm = false

    @observable happyUnhappy = false

    state

    @observable showFailedData = false

    failedData = {}

    @observable hasFailedData = false

    failedDataRowIds = []

    faildeDataColIds = []

    initialResponse

    handleInput = (e, element) => {
        switch (element) {
            case 'surveyId':
                this.request.surveyId = e.target.value
                break
            case 'langCode':
                this.request.langcode = e.target.value
                break
            case 'file':
                this.file = e.target.files[0]
                break
            default:
        }
    }

    initializeVariables = () => {
        this.allData = []
        this.tableData = []
        this.file = null
        this.request.surveyId = ''
        this.showFailedData = false
        this.hasFailedData = false
        this.pending = false
        this.happyUnhappy = false
        this.failedDataRowIds = []
        this.faildeDataColIds = []
        this.initialResponse = {}
        this.tableHeaders = []
        this.request.langcode = 'en_GB'
        this.initializeTableColumns()
    }

    getDivElements = (key) => {
        switch (key) {
            case 'red':
                return (
                    <div className="tableDivStyle tableRedDiv" />
                )
            case 'green':
                return (
                    <div className="tableDivStyle tableGreenDiv" />
                )
            case 'white':
                return (
                    <div className="tableDivStyle" />
                )
            default:
                return null
        }
    }

    getExpandableDataRow = (row) => {
        const filterArray = ['id', 'newSurveyData', 'newSurveyUser', 'clicked']
        this.expandableData = Object.keys(row)
            .filter((key) => !filterArray.includes(key))
            .reduce((acc, key) => {
                acc[key] = row[key]
                return acc
            }, {})
        return (
            <>
                {row.newSurveyUser ? (
                    <>
                        <strong>User Details</strong>
                        {this.userDetails.map((data) => (
                            <p>
                                {`${data} : `}
                                <span>
                                    {`${row[data]}`}
                                </span>
                            </p>
                        ))}
                        <br />
                    </>
                ) : null}
                <strong>Survey Data</strong>
                {!this.showFailedData ? Object.keys(this.expandableData)
                    .filter((fil) => !this.userDetails.includes(fil))
                    .map((i) => (
                        <p className={this.getstyle(row[i])}>
                            {`[${i}] : `}
                            <span>
                                {`${this.getValue(row[i])}`}
                            </span>

                        </p>
                    )) : this.renderFailedData(row)}
            </>
        )
    }

    initializeTableColumns = () => {
        this.tableColumns = [
            {
                key: 'id',
                name: 'ID',
                cellClass: 'cell',
                dataTransform: (val) => <p className="idText">{val}</p>,
            },
            {
                key: 'newSurveyData',
                name: 'new Survey Data',
                expandableDataColumn: true,
                cellClass: 'cell',
                dataTransform: (val, row) => {
                    if (row.hasOwnProperty('clicked')) return this.getExpandableDataRow(row)
                    if (!val) return this.getDivElements('red')
                    return this.getDivElements('green')
                },
            },
            {
                key: 'newSurveyUser',
                name: 'new Survey User',
                cellClass: 'cell',
                dataTransform: (val) => {
                    if (!val) return this.getDivElements('red')
                    return this.getDivElements('green')
                },
            },
        ]
    }

    validate = () => {
        if (this.request.surveyId === '') {
            throw new Error('Insert a Survey Id')
        }
        if (!this.file) {
            throw new Error('Insert a file')
        }
    }

    togleShowFailedData = () => {
        this.showFailedData = !this.showFailedData
        this.initializeTableColumns()
        if (this.showFailedData) {
            this.tableData = []
            this.failedDatafetch(0, this.responseMetadata.totalRecordsWithCellUpdateFailures)
        } else {
            this.tableData = []
            this.tableData = this.allData
            this.getTableColumns(this.initialResponse)
        }
    }

    getFailedTableData = (response) => {
        response.forEach((element) => {
            const obj = {}
            element.forEach((item, index) => {
                if (index > 1) {
                    obj.id = item.importRecordId
                    this.processRows(obj, item, item.importRecordId)
                }
                if (index === 1) {
                    obj.newSurveyUser = item.isNew
                    Object.keys(item).forEach((itm) => { obj[itm] = item[itm] })
                }
                if (index === 0) {
                    obj.newSurveyData = item.isNew
                }
            })
            this.tableData.push(obj)
        })
    }

    fileUploadRequest = () => {
        const httpUrl = this.store.http.gatewayUrl
        const socketUrl = httpUrl.replace(/https:\/\//, 'wss://').replace(/http:\/\//, 'ws://')
        let query = 'target=import'
        query += '&method=surveyDataImport'
        query += `&token=${this.store.token}`
        this.socket = io(socketUrl, {
            query,
        })
        this.socket.on('connection', () => {
            this.socket.emit('data', JSON.stringify(this.request))
        })

        this.socket.on('response', (response) => {
            const parsedResponse = JSON.parse(response)
            this.initialResponse = parsedResponse
            try {
                if (parsedResponse.kind === 'importErrorResponse') {
                    throw new Error(`Something went wrong : ${response}`)
                } else if ((parsedResponse.kind === 'importInfoResponse' || parsedResponse.kind === 'importSuccesResponse')) {
                    switch (this.state) {
                        case 'happy':
                            this.store.addNotification(null, parsedResponse.success, 'success')
                            this.socket.disconnect()
                            this.uploadStarted = false
                            this.initializeVariables()
                            break
                        case 'unhappy':
                            if (parsedResponse.kind === 'importInfoResponse') {
                                this.store.addNotification(null, parsedResponse.info, 'success')
                            } else {
                                this.store.addNotification(null, parsedResponse.success, 'success')
                            }
                            this.socket.disconnect()
                            this.uploadStarted = false
                            this.initializeVariables()

                            break
                        default:
                            this.happyUnhappy = true
                            this.store.addNotification(null, parsedResponse.info, 'success')
                            break
                    }
                } else if (parsedResponse.kind === 'SurveyDataImportFileStatsResponse') {
                    this.processResponseMetadata(parsedResponse)
                    parsedResponse.fileHeaderDataCols
                        .filter((item) => !parsedResponse.allStaticColumns.includes(item))
                        .forEach((filteredItem) => {
                            const [initialKey, value] = filteredItem.split('] ')
                            const key = initialKey.replace(/\[|\]/gi, '').toUpperCase()
                            this.tableHeaders[key] = value
                        })
                    this.getTableData(this.initialResponse)
                    this.getTableColumns(this.initialResponse)
                    this.uploadStarted = true
                } else {
                    this.getFailedTableData(parsedResponse)
                    this.getTableColumns(this.initialResponse)
                }
            } catch (e) {
                this.pending = false
                this.store.addNotification(null, e.message, 'error')
            }
        })
    }

    processResponseMetadata = (response) => {
        Object.keys(this.responseMetadata).forEach((element) => {
            this.responseMetadata[element] = response[element]
        })
    }

    transform = (val) => {
        switch (val) {
            case 'empty':
                return this.getDivElements('white')

            case 'failure':
                return this.getDivElements('red')
            default:
                return this.getDivElements('green')
        }
    }

    getTableColumns = () => {
        let temp = []
        if (!this.showFailedData) {
            temp = Object.keys(this.tableHeaders)
                .map((filteredItem) => ({
                    key: filteredItem,
                    name: this.tableHeaders[filteredItem],
                    cellClass: 'cell',
                    dataTransform: (val, row) => this.transform(val, row),
                }))
        } else {
            temp = Object.keys(this.tableHeaders)
                .filter((item) => this.faildeDataColIds.includes(item))
                .map((filteredItem) => ({
                    key: filteredItem,
                    name: this.tableHeaders[filteredItem],
                    cellClass: 'cell',
                    dataTransform: (val, row) => this.transform(val, row),
                }))
        }

        this.tableColumns.push(...temp)
    }

    getstyle = (val) => {
        if (val === 'failure') return 'failedDataText'
        if (val !== 'empty') return 'greenStyleText'
        return ''
    }

    renderFailedData = (row) => {
        const id = row.id.split(' ')[0]
        if (Object.keys(this.failedData).includes(id)) {
            return (
                <>
                    {Object.keys(this.failedData[id]).map((element) => (
                        <p className="failedDataText">
                            {`[${element}] : `}
                            <span>
                                {this.failedData[id][element]}
                            </span>

                        </p>
                    ))}
                </>
            )
        }
        return null
    }

    getValue = (val) => {
        const filters = ['failure', 'empty']
        if (!filters.includes(val)) return val
        return ''
    }

    processRows = (obj, item, i) => {
        if (item.kind === 'EmptyCell') {
            obj[item.cellMetadata] = 'empty'
        } else if (item.kind === 'CellUpdateFailure') {
            this.hasFailedData = true
            obj[item.cellMetadata] = 'failure'
            if (this.failedDataRowIds.includes(i)) {
                this.failedData[i][item.cellMetadata] = item
                    .originalValue
            } else {
                this.failedData[i] = {
                    [item.cellMetadata]: item
                        .originalValue,
                }
            }
            this.failedDataRowIds.push(i)
            if (!this.faildeDataColIds.includes(item.cellMetadata)) {
                this.faildeDataColIds.push(item.cellMetadata)
            }
        } else if (item.hasOwnProperty('originalValue')) {
            obj[item.cellMetadata] = item.originalValue
        } else {
            obj[item.cellMetadata] = ''
        }
    }

    getTableData = (response) => {
        response.paginatedResults.forEach((element, i) => {
            const obj = {}
            element.forEach((item, index) => {
                if (index > 1) {
                    this.processRows(obj, item, i + 1)
                }
                if (index === 1) {
                    obj.newSurveyUser = item.isNew
                    Object.keys(item).forEach((itm) => { obj[itm] = item[itm] })
                }
                if (index === 0) {
                    obj.newSurveyData = item.isNew
                }
                obj.id = i + 1
            })
            this.allData.push(obj)
            this.tableData = this.allData
        })
    }

    tableRowClick = (e, row) => {
        const val = this.tableData.filter((element) => (typeof (element.id) === 'string' && parseInt(element.id.split(' ')[0], 10) === row))
        if (val.length === 0) {
            const rowValues = this.tableData.filter((element) => element.id === row)
            if (typeof (row) === 'number') {
                const newRow = { ...rowValues[0] }
                newRow.clicked = true
                newRow.id = `${row} duplicate`
                let indexdata
                this.tableData.forEach((ele, ind) => {
                    if (ele.id === row) {
                        indexdata = ind
                    }
                })
                this.tableData.splice(indexdata + 1, 0, newRow)
            }
        } else {
            const temp = this.tableData.filter((item) => !(item.id === val[0].id))
            this.tableData = temp
        }
    }

    getFileNameRequest = () => {
        this.pending = true
        const httpUrl = this.store.http.gatewayUrl
        const socketUrl = httpUrl.replace(/https:\/\//, 'wss://').replace(/http:\/\//, 'ws://')
        let query = 'target=import'
        query += '&method=fileUpload'
        query += `&token=${this.store.token}`
        this.socket = io(socketUrl, {
            query,
        })
        this.socket.on('connection', () => {
            this.socket.emit('data', this.file)
        })

        this.socket.on('response', (response) => {
            this.request.fileName = response.split('/').pop()
            this.socket.disconnect()
            this.fileUploadRequest()
        })

        this.socket.onerror = () => {
            this.socket.disconnect()
        }
    }

    confirmRequest = () => {
        this.state = 'confirm'
        this.socket.emit('data', JSON.stringify({
            kind: 'SurveyDataImportConfirmationRequest',
        }))
    }

    handleCancel = () => {
        this.uploadStarted = false
        this.initializeVariables()
        this.socket.disconnect()
    }

    handleHappy = () => {
        this.state = 'happy'
        this.socket.emit('data', JSON.stringify({
            kind: 'Happy',
        }))
    }

    handleUnhappy = () => {
        this.state = 'unhappy'
        this.socket.emit('data', JSON.stringify({
            kind: 'Unhappy',
        }))
    }

    failedDatafetch = (start, rowCount) => {
        this.socket.emit('data', JSON.stringify({
            kind: 'paginatedResults',
            recordNumber: start,
            recordsPerPage: rowCount,
            showOnlyRowsWithCellUpdateFailures: this.showFailedData,
        }))
    }

    uploadFile = () => {
        try {
            this.validate()
            this.getFileNameRequest()
        } catch (e) {
            this.pending = false
            this.store.addNotification(null, `Something went wrong: ${e.message}`, 'error')
        }
    }
}
export default SurveyDataImportStore
